import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import {
  PlanBenefitsContainer,
  BenefitItem,
  BenefitHeader,
  BenefitTitle,
  BenefitList,
  BenefitListItem,
  DottedSeparator,
  LearnMoreLink,
  TickLogo
} from "./styles";
import DiamondIcon from "@public/images/dashcam/DiamondVectorPurple.svg";
import TickLogoSvg from "@public/images/dashcam/tickLogo.svg";
import DiamondIconBlack from "@public/images/dashcam/DiamondVectorBlack.svg"
import CloneChildren from "@components/children";
export interface IBenefit {
  title: string;
  items: string[];
}

export interface IPlanBenefits extends CommonProps {
  benefits?: IBenefit[];
  learnMoreText?: string;
  isDashcamPlan?: boolean;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const PlanBenefits = (props: IPlanBenefits) => {
  
  const {
    is_visible,
    benefits,
    learnMoreText,
    styles,
    isDashcamPlan,
    actions,
    children,
    id
  } = props;
   
  const {learn_more_on_click} = actions || {};

  const handleClick = () => {
    if( learn_more_on_click.length > 0){
      learn_more_on_click.forEach((eachFunc: any) => {
        typeof eachFunc.funCall === "function" &&
          eachFunc.funCall(eachFunc.args);
      });
    }
  }
  
  return (id && is_visible) || !id ? (
    <PlanBenefitsContainer styles={styles}>
      {benefits?.map((benefit, index) => (
        <React.Fragment key={index}>
          <BenefitItem>
            <BenefitHeader>
              {isDashcamPlan ? <DiamondIcon/>  : <DiamondIconBlack/>}
              <BenefitTitle isDashcamPlan={isDashcamPlan}>{benefit.title}</BenefitTitle>
            </BenefitHeader>
            <BenefitList>
              {benefit.items.map((item, itemIndex) => (
                <BenefitListItem key={itemIndex}>
                  <TickLogo>
                    <TickLogoSvg/>
                  </TickLogo>
                  <span dangerouslySetInnerHTML={{ __html: item }} />
                </BenefitListItem>
              ))}
            </BenefitList>
          </BenefitItem>
          {index < benefits.length - 1 && <DottedSeparator />}
        </React.Fragment>
      ))}
      
      {learnMoreText && (
        <LearnMoreLink onClick={handleClick}>
          {learnMoreText} →
        </LearnMoreLink>
      )}
      {children && <CloneChildren>{children}</CloneChildren>}
    </PlanBenefitsContainer>
  ) : null;
};

export default connect(mapStateToProps)(PlanBenefits);
